import { Breadcrumb, Timeline } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ActiveDotIcon, BackIcon, CloseIcon, DetailIcon, InactiveDotIcon } from "../../../asset";
import Accordion from "../../../component/accordion/Accordion";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import MapsSmall from "../../../component/maps/MapsSmall";
import Delete from "../../../component/modal/ModalDelete";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { ROUTES } from "../../../constant/routeConstant";
import style from "./CustomerAdd.module.css";
import { useSelector } from "react-redux";
import ModalMaps from "../../../component/modal/ModalMaps";
import moment from "moment";
import CustomDivider from "../../../component/divider/CustomDivider";

const CustomerDetail = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [detail, setDetail] = useState([]);
  const location = useLocation();
  const [index, setIndex] = useState();
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [loc, setLoc] = useState("")
  const [loc2, setLoc2] = useState("")
  const [userManagementOpen, setUserManagementOpen] = useState(false)
  const [managementHistoryList, setManagementHistoryList] = useState([])

  const [isOpenMaps, setIsOpenMaps] = useState(false)
  const api = GROLOG_URL;
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetBaseUrl = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { "Authorization": token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(`audit/v1/grolog/audit?page=1&filter=table_name eq customer, primary_key eq ${location.state}`)

    const data = res?.data?.payload
    const reorderedData = []

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element)
    }

    setManagementHistoryList(reorderedData)
  }

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }


  const fetchData = async () => {
    setLoading(true)
    let res = await doGet(`/customer/${location.state}`, token);
    setDetail(res?.data?.payload?.data);
    getManagementHistoryList()
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);

  const clickCard = (i, open) => {
    setIndex(i);
    setIsOpen(isOpen ? false : true);
  };

  const backToCustList = () => {
    navigate(ROUTES.CUSTOMER.LIST);
  };

  const toMapsFull = (el) => {
    navigate(ROUTES.CUSTOMER.MAPS, { state: el });
  };

  const getAdr = (long, latt) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latt, long);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        for (let i = 0; i < results[0].address_components.length; i++) {
          const component = results[0].address_components[i];
          if (component.types.includes("administrative_area_level_3")) {
            setLoc(component.long_name)
            return; // Exit the loop if postal code is found
          } if (component.types.includes("administrative_area_level_4")) {
            setLoc2(component.long_name)
            setIsOpenMaps(true)
          }
        }

      } else {
        console.log("Geocoder failed due to:", status);
      }
    })

    setIsOpenMaps(true)
  }

  return (
    <>
      <Delete
        data={detail.updated_at}
        id={detail.customer_id}
        delete={showDelete}
        title={detail.first_name}
        url={"customer"}
        action={() => setShowDelete(false)}
        route={ROUTES.CUSTOMER.LIST}
        token={token}
        param={param}
      // refresh={fetchData()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Master</Breadcrumb.Item>
            <Breadcrumb.Item>Customer</Breadcrumb.Item>
            <Breadcrumb.Item>Detail {detail.customer_id} - {detail.first_name + " " + detail.last_name}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[22px]">
            <div className="flex gap-[22px] cursor-pointer" onClick={() => backToCustList()}>
              <img
                src={BackIcon}
                alt=""
              />
              <h1 className="font-sans-bold text-2xl" id="title">
                Detail {detail.customer_id} - {detail.first_name + " " + detail.last_name}
              </h1>
            </div>
          </div>
          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.updated_at, true)}</strong></p>
          </div>
        </div>

        {/* <DataManagementHistory/> */}

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          {
            !loading ?
              <>
                <div className={style.tabsContainer + ""}>
                  <div className="flex flex-col gap-[40px]">
                    <div>
                      {/* <h3 className="font-roboto text-[20px] font-bold mb-6 mt-6">
                        {t("Customer Information")}
                      </h3> */}
                                                    <CustomDivider
                                                      name={"Customer Information"}
                                                    />

                      <div className="flex">
                        {/* line one */}
                        <div className="gap-[40px] mb-[24px]">
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Company Profile ID")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.company_profile_id}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("DRIVER:FIRST_NAME")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.first_name}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("DRIVER:LAST_NAME")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail?.last_name ? detail?.last_name : "-"}
                            </h4>
                          </div>
                        </div>
                        {/* line two */}
                        <div className="gap-[40px] mb-[16px]">
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("E-mail")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail.email ? detail.email : "-"}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("DRIVER:PHONE")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail.phone}
                            </h4>
                          </div>
                          <div className="w-[500px] mb-[24px]">
                            <label className="font-roboto text-[14px] text-[#818181]">
                              {t("Fax")}
                            </label>
                            <h4 className="font-roboto text-[20px] text-[#424242]">
                              {detail.fax ? "+62-" + detail.fax : "-"}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {detail?.customer_address?.map((el, i) => {
                    return (
                      <div id={i}>
                        <Accordion
                          onClick={() => clickCard(i, isOpen)}
                          index={i}
                          i={index}
                          isOpen={isOpen}
                          address={el?.address}
                          body={
                            <>
                              {isOpen === true && i === index ? (
                                <>
                                  <ModalMaps show={isOpenMaps}
                                    address={el.address}
                                    latitude={el.latitude}
                                    longitude={el.longitude}
                                    onClose={() => setIsOpenMaps(false)}
                                    loc={loc + ", " + (loc2 ? loc2 + ", " : "") + el.longitude + ", " + el.latitude}
                                  />
                                  <div className="h-full bg-white-100 opacity-100 rounded-b-lg p-4">
                                    <div className="flex">
                                      <div>
                                        <div className="flex">
                                          <div className="gap-[40px] mb-[24px] ml-6">
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Recipient's Name")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.recipient_name ? el?.recipient_name : "-"}
                                              </h4>
                                            </div>
                                            {/* <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Island")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.island}
                                              </h4>
                                            </div> */}
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Sub District")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.sub_district}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Neighbourhood")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.neighbourhood ? el?.neighbourhood : "-"}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Longitude")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.longitude}
                                              </h4>
                                            </div>

                                          </div>
                                          {/* line two */}
                                          <div className="gap-[40px] mb-[16px]">
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Recipient's Phone")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.recipient_phone ? el?.recipient_phone : "-"}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Province")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.province}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Urban Village")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.urban_village}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Hamlet")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.hamlet ? el.hamlet : "-"}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Latitude")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.latitude}
                                              </h4>
                                            </div>
                                          </div>
                                          {/* line 3 */}
                                          <div className="gap-[40px] mb-[16px]">
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Country")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.country}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer District")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.district}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Address")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el?.address}
                                              </h4>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-[14px] text-[#818181]">
                                                {t("Customer Postal Code")}
                                              </label>
                                              <h4 className="font-roboto text-[20px] text-[#424242]">
                                                {el.postal_code}
                                              </h4>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="w-[600px] h- ml-[20px]">
                                          <label className="font-roboto text-[14px] text-[#818181]">
                                            {t("Pinpoint")}
                                          </label>
                                          <MapsSmall
                                            long={el.longitude}
                                            lat={el.latitude}
                                            onClicks={() =>
                                              getAdr(el.longitude, el.latitude)
                                            } />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </>
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              </>
              :
              "...loading"
          }

          <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
            <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
              <img src={CloseIcon} alt="" />
            </button>

            <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
            <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at)}</strong></p>


            <div className={style.timelineContainer}>
              <Timeline>
                {
                  managementHistoryList.map((item, index) => {
                    if (index === 0) {
                      return (
                        <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                      )
                    } else {
                      return (
                        <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                      )
                    }
                  })
                }
              </Timeline>
            </div>
          </aside>

        </div>
        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton actions="update"
            menu="customer"
            parent="master"
           text={t("DRIVER:EDIT")} action={() => navigate(ROUTES.CUSTOMER.EDIT, { state: detail.customer_id })} />
          <SecondaryButton actions="delete"
            menu="customer"
            parent="master"
           text={t("DRIVER:DELETE")} action={() => setShowDelete(true)} />
        </div>
      </div>
    </>
  );
};
export default CustomerDetail;
